<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>新增公告</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="开始时间:" prop="startDate">
                          <el-date-picker
                            v-model="SelectData.startDate"
                            :readonly="IsReadonlyCode"
                            placeholder="请选择开始时间"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="结束时间:" prop="endDate">
                          <el-date-picker
                            v-model="SelectData.endDate"
                            :readonly="IsReadonlyCode"
                            placeholder="请选择结束时间"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="公告标题:" prop="status">
                          <el-input
                            v-model="SelectData.title"
                            :readonly="IsReadonlyCode"
                            placeholder="请输入公告标题"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="公告内容：">
                          <MyCkdeitor
                            @sendContnet="getContent"
                            :content="SelectData.details"
                          ></MyCkdeitor>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { SelectNoticeById, ModifyNotice, AddNotice } from "@api/ApiNotice";
import MyCkdeitor from "../RichText/MyCkdeitor.vue";

export default {
  name: "NoticeEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  components: {
    MyCkdeitor,
  },
  data() {
    return {
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
    };
  },

  created() {},
  mounted() {},
  methods: {
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.IsReadonlyCode = true;

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData = {};
        return;
      } else if (type == "Modify") {
        _this.IsReadonlyCode = false;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }

      SelectNoticeById(id).then(function (data) {
        _this.SelectData = data;
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.SelectData = {};
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.SelectData = {};
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;
      if (!_this.validate()) return;
      let USER_INFO = JSON.parse(
          localStorage.getItem("USER_INFO")
      )
      if (_this.OpStatus == "Add") {
        this.SelectData.creatorName = USER_INFO.UserName;
        this.SelectData.releaseDate = new Date();
        this.SelectData.CompanyId = USER_INFO.CompanyId;
        AddNotice(this.SelectData).then(function (data) {
          _this.$message.success("新增成功!");
          _this.$emit("handle-confirm");
        });
      } else if (_this.OpStatus == "Modify") {
        ModifyNotice(this.SelectData).then(function (data) {
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        });
      }
    },
    validate() {
      if (!this.SelectData.startDate) {
        this.$message.error("开始时间是必须的!");
        return false;
      }
      if (!this.SelectData.endDate) {
        this.$message.error("结束时间是必须的!");
        return false;
      }
      if (!this.SelectData.title) {
        this.$message.error("公告标题是必须的!");
        return false;
      }
      if (!this.SelectData.details) {
        this.$message.error("公告内容是必须的!");
        return false;
      }
      return true;
    },
    //获取富文本编译器内容
    getContent(val) {
      this.SelectData.details = val;
    },
  },
};
</script>

<style lang="scss" scoped >
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
